module.exports = __webpack_public_path__ + "img/getting-hitched.d133b895.png";